"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.describeKeys = describeKeys;
exports.describeResources = describeResources;
exports.describeValues = describeValues;
exports.getTagTemplateList = getTagTemplateList;
exports.resetTagResources = resetTagResources;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _axios = _interopRequireDefault(require("@jdcloud/jelement-biz/dist/api/axios"));
function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }
var axios = new _axios.default({
  extra: {
    componentName: 'tag'
  }
});

// 获取标签keys
function describeKeys(_ref) {
  var regionId = _ref.regionId;
  return axios({
    url: '/openApi/resourcetag/describeKeys',
    method: 'POST',
    params: {
      regionId: regionId
    },
    data: {
      params: {
        tagKeysVo: {}
      }
    }
  });
}

// 获取标签values
function describeValues(_ref2) {
  var key = _ref2.key,
    regionId = _ref2.regionId;
  return axios({
    url: '/openApi/resourcetag/describeValues',
    method: 'POST',
    params: {
      regionId: regionId
    },
    data: {
      params: {
        tagValuesVo: {
          tagFilters: [{
            key: key
          }]
        }
      }
    }
  });
}

// 资源标签批量打标(替换)
function resetTagResources(_ref3) {
  var serviceCodes = _ref3.serviceCodes,
    regionId = _ref3.regionId,
    resourceTags = _ref3.resourceTags;
  return axios({
    url: '/openApi/resourcetag/resetTagResources',
    method: 'POST',
    params: {
      regionId: regionId
    },
    data: {
      params: {
        resetTagResources: {
          serviceCodes: serviceCodes,
          resourceTags: resourceTags
        }
      }
    }
  });
}

// 获得资源 jrn 与tag mapping
function describeResources(_ref4) {
  var serviceCodes = _ref4.serviceCodes,
    resourceIds = _ref4.resourceIds,
    _ref4$regionId = _ref4.regionId,
    regionId = _ref4$regionId === void 0 ? 'cn-north-1' : _ref4$regionId;
  return axios({
    url: '/openApi/resourcetag/describeResources',
    method: 'POST',
    params: {
      regionId: regionId
    },
    data: {
      params: {
        resourceVo: {
          serviceCodes: serviceCodes,
          resourceIds: resourceIds
        }
      }
    }
  });
}
function getTagTemplateList(options) {
  return axios(_objectSpread({
    url: '/openApi/resourcegroup/getTagTemplateList',
    method: 'POST'
  }, options));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@jdcloud/jelement-biz/dist/api/tag-edit.js
// module id = jCo4
// module chunks = 19